import { useState, useRef, useEffect } from "react";
import HeaderNav from "../../../../../Components/Dahboard Header/HeaderNav/HeaderNav";
import classes from "./BankBankRecon.module.css";
import { Calendar } from "lucide-react";
import printer from "../../../../../Assets/Printer.png";
import tick from "../../../../../Assets/check.png";
import refresh from "../../../../../Assets/ArrowsClockwise.png";
import save from "../../../../../Assets/FloppyDisk.png";
import cancel from "../../../../../Assets/X.png";
import uploadbtn from "../../../../../Assets/UploadSimple.png";
import filenotify from "../../../../../Assets/fileicon.png";
import fileinfo from "../../../../../Assets/Info.png";
import downloadbtn from "../../../../../Assets/DownloadSimple.png";
import chat from "../../../../../Assets/ChatCircle.png";
import Footer from "../../../../../Components/Footer/Footer";
import { Link, useLocation, useNavigate } from "react-router";
import * as XLSX from 'xlsx';
import api from "../../../../../Components/API/Api";
import Swal from 'sweetalert2';

const ChartofAccountPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const uploadedFiles = location.state?.files || [];
  const uuid = location.state?.uuid; // UUID passed from previous page
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const [excelData, setExcelData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Debug: Log uuid when component mounts
  useEffect(() => {
    console.log('ChartofAccountPreview - location.state:', location.state);
    console.log('ChartofAccountPreview - UUID received:', uuid);
    console.log('ChartofAccountPreview - UUID type:', typeof uuid);
    console.log('ChartofAccountPreview - UUID is falsy:', !uuid);
    console.log('ChartofAccountPreview - Files received:', uploadedFiles);
  }, [uuid, uploadedFiles]);

  // Parse Excel file using the xlsx library
  useEffect(() => {
    if (uploadedFiles.length > 0 && (uploadedFiles[currentFileIndex]?.name.endsWith('.xlsx') || uploadedFiles[currentFileIndex]?.name.endsWith('.xls'))) {
      parseExcelFile(uploadedFiles[currentFileIndex]);
    }
  }, [currentFileIndex, uploadedFiles]);

  const parseExcelFile = async (fileData) => {
    try {
      // Convert base64 to binary string
      const bstr = atob(fileData.data.split(',')[1]);
      const ab = new ArrayBuffer(bstr.length);
      const view = new Uint8Array(ab);
      for (let i = 0; i < bstr.length; i++) {
        view[i] = bstr.charCodeAt(i) & 0xFF;
      }
      
      // Parse workbook
      const workbook = XLSX.read(ab, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      
      // Convert to JSON
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      setExcelData(data);
    } catch (error) {
      console.error('Error parsing Excel file:', error);
      setExcelData(null);
    }
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("Current Month");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [viewAllData, setViewAllData] = useState(false);
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const wrapperRef = useRef(null);
  const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];

  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCalendarClick = (e) => {
    e.stopPropagation();
    inputRef.current.showPicker(); // shows native picker in modern browsers
  };

  const handleMonthChange = (e) => {
    const [year, month] = e.target.value.split("-");
    const monthName = new Date(e.target.value).toLocaleString("default", {
      month: "long",
    });
    setSelectedMonth(`${monthName} ${year}`);
  };

  const handleUploadDifferentFile = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (e) => {
    if (e.target.files) {
      handleFiles(e.target.files);
    }
  };

  const handleFiles = (files) => {
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      const fileData = [];
      let filesRead = 0;

      fileArray.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          fileData.push({
            name: file.name,
            type: file.type,
            size: file.size,
            data: reader.result,
          });
          filesRead++;

          if (filesRead === fileArray.length) {
            console.log("Files selected:", fileData);
            navigate("/accounting/bankstatement-preview", { state: { files: fileData } });
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const handleSubmitChartOfAccount = async () => {
    try {
      if (!uuid) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'UUID is missing. Unable to save chart of account.',
        });
        return;
      }

      setIsSubmitting(true);

      console.log('Submitting chart of account with UUID:', uuid);

      const response = await api.post('/v1/save_account', {
        uuid: uuid,
      });

      setIsSubmitting(false);

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Chart of Account has been saved successfully!',
        }).then(() => {
          navigate('/upload-opening-bal');
        });
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error('Error saving chart of account:', error);
      
      const errorMessage = error.response?.data?.message || error.message || 'Failed to save chart of account. Please try again.';
      
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };
  return (
    <div className={classes.bodyxyz}>
      <HeaderNav />
      <section className={classes.bankbody}>
        {/* <div className={classes.actions}>
          <Link to='/transactions/sales-invoice/sales'><button className={classes.btns}>Sales Invoice</button></Link>
          <Link to='/inventory/purchaseOrder'><button className={classes.btns}>Purchase order</button></Link>
          <button className={classes.btnst}>Reconcilation</button>
          <Link to='/settings/product-services'><button className={`${classes.btns} ${classes.greens}`}>Product & Services</button></Link>
        </div> */}

        <header className={classes.header}>
          <div className={classes.header1}>
            <h2 className={classes.Title}>Review Chart of Accounts</h2>
            <h1 className={classes.Titles}>
              Check that this is the correct file before submitting to complete your setup
            </h1>
          </div>
          <div className={classes.header2}>
            <div className={classes.wrapper} ref={wrapperRef}>
              <div
                className={classes.combobox}
                onClick={handleUploadDifferentFile}
              > <span className={classes.comboboxText}>Upload different file </span>

                <input
                  ref={fileInputRef}
                  type="file"
                  className={classes.hiddenInput}
                  onChange={handleFileInputChange}
                  accept=".pdf,.csv,.xlsx,.xls"
                  style={{ display: 'none' }}
                />
              </div>
            </div>
          </div>
        </header>

        {uploadedFiles.length > 0 && (
          <div className={classes.filePreviewdtls}>
            <img src={filenotify} alt="File" className={classes.filenotify} />
            <div>
              <p className={classes.filenamestle}>{uploadedFiles[currentFileIndex]?.name}</p>
              <div className={classes.filetypesdtls}>
                <p style={{ marginBottom: '0px'}}>{uploadedFiles[currentFileIndex]?.type.split('/')[1].toUpperCase() || 'FILE'}</p>
                <p style={{ marginBottom: '0px'}}>•</p>
                <p style={{ marginBottom: '0px'}}>{(uploadedFiles[currentFileIndex]?.size / 1024).toFixed(2)} KB</p>
                <p style={{ marginBottom: '0px'}}>•</p>
                <p style={{ marginBottom: '0px'}}>Uploaded just now</p>
              </div>
            </div>
          </div>
        )}
        <div className={classes.filePreviewdtlsii}> 
          <img src={fileinfo} alt="Download" className={classes.fileinfo} />
          <p className={classes.reviewtxt}>Review carefully. Make sure the account codes, names, and types match what you expect before submitting. You can upload a different file if something looks wrong.</p>
        </div>
      </section>
      <section className={classes.cardsect}>
        <div className={classes.reconciliationContainer}>
          {uploadedFiles.length > 0 ? (
            <div className={classes.filePreviewSection}>
              {uploadedFiles[currentFileIndex]?.type.includes('pdf') ? (
                <iframe
                  src={uploadedFiles[currentFileIndex]?.data}
                  className={classes.pdfPreview}
                  title="PDF Preview"
                />
              ) : uploadedFiles[currentFileIndex]?.name.endsWith('.xlsx') || uploadedFiles[currentFileIndex]?.name.endsWith('.xls') ? (
                <div className={classes.spreadsheetPreview}>
                  {excelData && excelData.length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
                      {/* Data Summary and Controls */}
                      <div style={{
                        padding: '12px 16px',
                        backgroundColor: '#f5f5f5',
                        borderBottom: '1px solid #ddd',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '12px',
                        flexShrink: 0
                      }}>
                        <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                          <span style={{ fontWeight: '600', color: '#333' }}>
                            Total Rows: <strong>{excelData.length}</strong>
                          </span>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <label style={{ fontSize: '14px', color: '#555' }}>Rows per page:</label>
                            <select
                              value={rowsPerPage}
                              onChange={(e) => {
                                setRowsPerPage(Number(e.target.value));
                                setCurrentPage(0);
                                setViewAllData(false);
                              }}
                              style={{
                                padding: '6px 10px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                cursor: 'pointer',
                                fontSize: '14px'
                              }}
                            >
                              {ROWS_PER_PAGE_OPTIONS.map(option => (
                                <option key={option} value={option}>{option}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            setViewAllData(!viewAllData);
                            setCurrentPage(0);
                          }}
                          style={{
                            padding: '8px 16px',
                            backgroundColor: viewAllData ? '#4CAF50' : '#2196F3',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '600',
                            transition: 'background-color 0.3s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = viewAllData ? '#45a049' : '#0b7dda'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = viewAllData ? '#4CAF50' : '#2196F3'}
                        >
                          {viewAllData ? '✓ View All (Active)' : 'View All Data'}
                        </button>
                      </div>

                      {/* Table */}
                      <div style={{ 
                        width: '100%', 
                        flex: 1, 
                        minHeight: 0,
                        overflowX: 'auto', 
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        <table className={classes.excelTable}>
                          <tbody>
                            {(() => {
                              let displayData;
                              if (viewAllData) {
                                displayData = excelData;
                              } else {
                                const startIdx = currentPage * rowsPerPage;
                                displayData = excelData.slice(startIdx, startIdx + rowsPerPage);
                              }
                              
                              return displayData.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell || ''}</td>
                                  ))}
                                </tr>
                              ));
                            })()}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination Controls */}
                      {!viewAllData && (
                        <div style={{
                          padding: '12px 16px',
                          backgroundColor: '#f5f5f5',
                          borderTop: '1px solid #ddd',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          gap: '12px',
                          flexShrink: 0
                        }}>
                          <span style={{ fontSize: '14px', color: '#555' }}>
                            Showing {Math.min((currentPage * rowsPerPage) + 1, excelData.length)} - {Math.min((currentPage + 1) * rowsPerPage, excelData.length)} of {excelData.length} rows
                          </span>
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                              onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
                              disabled={currentPage === 0}
                              style={{
                                padding: '8px 12px',
                                backgroundColor: currentPage === 0 ? '#ccc' : '#2196F3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '600'
                              }}
                            >
                              ← Previous
                            </button>
                            <span style={{
                              padding: '8px 12px',
                              backgroundColor: '#e3f2fd',
                              borderRadius: '4px',
                              fontSize: '14px',
                              fontWeight: '600',
                              minWidth: '80px',
                              textAlign: 'center'
                            }}>
                              Page {currentPage + 1} of {Math.ceil(excelData.length / rowsPerPage)}
                            </span>
                            <button
                              onClick={() => setCurrentPage(prev => {
                                const maxPage = Math.ceil(excelData.length / rowsPerPage) - 1;
                                return Math.min(maxPage, prev + 1);
                              })}
                              disabled={currentPage >= Math.ceil(excelData.length / rowsPerPage) - 1}
                              style={{
                                padding: '8px 12px',
                                backgroundColor: currentPage >= Math.ceil(excelData.length / rowsPerPage) - 1 ? '#ccc' : '#2196F3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: currentPage >= Math.ceil(excelData.length / rowsPerPage) - 1 ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '600'
                              }}
                            >
                              Next →
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className={classes.excelLoadingContainer}>
                      <p className={classes.previewPlaceholder}>Loading Excel file...</p>
                      <p className={classes.previewSubtext}>{uploadedFiles[currentFileIndex]?.name}</p>
                    </div>
                  )}
                </div>
              ) : uploadedFiles[currentFileIndex]?.type.includes('spreadsheet') || uploadedFiles[currentFileIndex]?.name.endsWith('.csv') ? (
                <div className={classes.spreadsheetPreview}>
                  <p className={classes.previewPlaceholder}>Spreadsheet file preview</p>
                  <p className={classes.previewSubtext}>{uploadedFiles[currentFileIndex]?.name}</p>
                </div>
              ) : (
                <div className={classes.filePreviewPlaceholder}>
                  <p className={classes.previewPlaceholder}>File Preview</p>
                  <p className={classes.previewSubtext}>{uploadedFiles[currentFileIndex]?.name}</p>
                </div>
              )}
              {uploadedFiles.length > 1 && (
                <div className={classes.fileNavigationButtons}>
                  <button
                    onClick={() => setCurrentFileIndex((prev) => (prev > 0 ? prev - 1 : uploadedFiles.length - 1))}
                    className={classes.navButton}
                  >
                    Previous
                  </button>
                  <span>{currentFileIndex + 1} of {uploadedFiles.length}</span>
                  <button
                    onClick={() => setCurrentFileIndex((prev) => (prev < uploadedFiles.length - 1 ? prev + 1 : 0))}
                    className={classes.navButton}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className={classes.noFilesPlaceholder}>
              <p>No file uploaded. Please upload a chart of accounts file to preview.</p>
            </div>
          )}
        </div>
      </section>
<div className={classes.btnsubmit}>
  <button className={classes.cnclbtn} onClick={handleCancel} disabled={isSubmitting}>Cancel </button>
  <button className={classes.submitbtn} onClick={handleSubmitChartOfAccount} disabled={isSubmitting}>
    {isSubmitting ? 'Submitting...' : 'Submit Chart of Accounts'}
  </button>
</div>

      <Footer />
    </div>
  );
};

export default ChartofAccountPreview;
